import { IPromise } from 'angular'
import { ApiProduct, ApiResponse } from '@vend/types'

import { extractData } from '../../../util/extract-data'
import { $http } from '../../../ng-compat/imports'

const PRODUCTS_ENDPOINT = '/api/2.0/products'

/**
 * Functions for querying the products API for product data.
 */

/**
 * Requests data for a product from the api.
 *
 * @param productId
 *        The id of the product to retrieve
 *
 * @return A promise resolved when the product has been retrieved
 */
export function getProduct(productId: string): IPromise<ApiProduct> {
  return $http
    .get<ApiResponse<ApiProduct>>(`${PRODUCTS_ENDPOINT}/${productId}`)
    .then(extractData)
}
